import { api } from "@/lib/api";

const KEY = "offernest_location";

export const getLocalLocation = () => {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch { return null; }
};

export const setLocalLocation = (loc) => {
    const value = { ...loc, updated_at: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(value));
    // Broadcast so cross-component listeners (nav chip) refresh.
    window.dispatchEvent(new CustomEvent("offernest:location", { detail: value }));
    return value;
};

export const clearLocalLocation = () => {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new CustomEvent("offernest:location", { detail: null }));
};

export const listCountries = () => api.get("/geo/countries").then((r) => r.data);
export const listStates = (cc = "IN") => api.get(`/geo/states?country_code=${cc}`).then((r) => r.data);
export const reverseGeocode = (lat, lng) => api.post("/geo/reverse-geocode", { lat, lng }).then((r) => r.data);
export const patchMyLocation = (payload) => api.patch("/me/location", payload).then((r) => r.data);

/** Request the browser's geolocation permission + coordinates. */
export const requestGeolocation = () =>
    new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) return reject(new Error("Geolocation not supported"));
        navigator.geolocation.getCurrentPosition(
            (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
            (err) => reject(err),
            { timeout: 8000, enableHighAccuracy: false },
        );
    });
